module.exports = __webpack_public_path__ + "img/close-green.1d043d8f.svg";